import 'whatwg-fetch';
import './style.scss';
import { initApp } from './features/app';

// disable BFCache
window.addEventListener('unload', () => {});

initApp();
